<main class="dialog-body">
    <div class="dialog-header">
        <div class="dialog-header-text">
            {{ data.title }}
        </div>
        <div class="cros-icon" (click)="onCancel()">
            <img src="assets/images/cross-icon.svg" class="cross-icon" />
        </div>
    </div>

    <mat-dialog-content>
        <ng-container *ngIf="data.template">
            <ng-container [ngTemplateOutlet]="data.template"></ng-container>
        </ng-container>
    </mat-dialog-content>

    <mat-dialog-actions class="action-buttons">
        <button *ngIf="data.cancelText" class="cancel-button" (click)="onCancel()" [disabled]="loading">
            {{ data.cancelText }}
        </button>

        <!-- Dynamic button text based on operation -->
        <button *ngIf="data.confirmText" class="update-button" (click)="onConfirm()" [disabled]="loading">
            <span *ngIf="!loading">{{ data.confirmText }}</span>
            <span *ngIf="loading" class="submit-loading">
                <span class="spinner"></span>
                {{ data.confirmText }}
            </span>
        </button>

        <button *ngIf="data.SaveText" class="save-button" (click)="onConfirm()" [disabled]="loading">
            <span *ngIf="!loading">{{ data.SaveText }}</span>
            <span *ngIf="loading" class="submit-loading">
                <span class="spinner"></span>
                Saving...
            </span>
        </button>

        <button *ngIf="data.SyncText" class="synce-button" (click)="onConfirm()" [disabled]="loading">
            {{ data.SyncText }}
        </button>
    </mat-dialog-actions>
</main>